// do this whenever you load a page
// so also when loading a new history.js page
// often occurs in <main> or changing navigations

// imports --------------------------------------------------------------------
import { fixLocalTesting } from '../js_vendor/FixLocalTesting.js';

// import * as Cookies from './0-cookies-v3.1.js';
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';
// import * as Example from './example.js';
import * as Colcade from 'colcade'; //
import * as MediaItems from './6-media-items-v1.8.js';

// import * as MyHistory from './history-v2.0.js';
// import * as VideoEmbed from './6-video-embed-v2.4.js';

// Import Swiper JS
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation.min.css';
Swiper.use([Navigation]);

// exported variables ---------------------------------------------------------

// local variables ------------------------------------------------------------
let staggerTotal = 0;
const replacedChar = '±'; // replace this character with an image in words/lines

const navItemClasses = ['footer__link'];

// new page function ----------------------------------------------------------
export const setPage = () => {
  // sets all the pages
  // console.log('setPage');

  // setters -----------------------------------------------
  fixLocalTesting(); // before historySetPage, because it might change URLs

  // set active menu item -------------------------------------
  const cleanUrl = window.location.href.split('?')[0].split('#')[0];
  const navItemsEls = document.querySelectorAll('a');

  navItemsEls.forEach(navItemEl => {
    navItemClasses.forEach(navItemClass => {
      if (!navItemEl.classList.contains(navItemClass)) return;

      navItemEl.classList.remove(navItemClass + '--active');
      const href = navItemEl.getAttribute('href');

      if (href === cleanUrl) {
        navItemEl.classList.add(navItemClass + '--active');
      } else {
        for (let j = 0; j < $arPostTypes.length; j++) {
          if (
            cleanUrl.indexOf('/' + $arPostTypes[j] + '/') > 0
          && href == $url + $arPostTypes[j] + '/'
          ) {
            navItemEl.classList.add(navItemClass + '--active');
          }
        }
      }
    });
  });

  if (typeof MyHistory !== 'undefined') MyHistory.historySetPage();
  // if ('setExample' in Example) Example.setExample();

  MediaItems.setMediaItems();

  const cloudBtnsEls = document.querySelectorAll('.button-cloud__button');
  // console.log({ cloudBtnsEls });
  cloudBtnsEls.forEach(cloudBtnEl => {
    const offsetY = Math.random() * 2 - 1; // random value between -1 and 1
    const offsetX = Math.random() * 2 - 1; // random value between -1 and 1

    // console.log({ offsetY, offsetX });
    cloudBtnEl.style.setProperty('--offset-y', `${offsetY}`);
    cloudBtnEl.style.setProperty('--offset-x', `${offsetX}`);
  });

  // home slider ------------------------------------------------
  const sliderEls = document.querySelectorAll('.slider');
  const swipers = [];
  sliderEls.forEach((el, id) => {
    let speed = id == 0 ? 1400 : 1600; // first slider is slower
    // console.log('setPage', id, speed);
    const swiper = new Swiper(el, {
      direction: 'horizontal',
      loop: true,
      touchStartPreventDefault: Vars.blTouch ? true : false,
      speed: speed,
      allowTouchMove: false,
    });
    
    swipers.push(swiper);

    // on change
    swiper.on('slideChange', () => {
      if (id !== 0) return; // only for first slider
      setSliderColors(el);
    });

    if (id === 0) setSliderColors(el); // set colors for first slider
  });

  // cars sliders ------------------------------------------------
  const cardsSliderEls = document.querySelectorAll('.cards__slider');
  cardsSliderEls.forEach(el => {
    const swiper = new Swiper(el, {
      direction: 'horizontal',
      loop: false,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      touchStartPreventDefault: Vars.blTouch ? true : false,
      speed: Vars.blTouch ? 400 : 800,
      slidesPerView: 'auto',
      slidesPerGroup: 2, // Move 2 slides per navigation click
      breakpoints: {
        0: {
          slidesPerGroup: 1
        },
        800: {
          slidesPerGroup: 2
        }
      },
    });
    swipers.push(swiper);
  });

  // Scroll.setColors(0);

  // start m animation -----------------------------------
  setTimeout(() => {
    const startEl = document.querySelector('.slider.m, .jumbotron__media.m, .jumbotron__m.m');
    if (startEl) {
      const classes = startEl.getAttribute('class');
      // if 'js-to' isn't in calsees return
      if (!classes || !classes.includes('js-to-')) return;

      startEl.classList.remove('m--thin');

      if (startEl.classList.contains('js-to-regular')) {
        startEl.classList.add('m--regular');
        startEl.classList.remove('js-to-regular');
      }

      if (startEl.classList.contains('js-to-bold')) {
        startEl.classList.add('m--bold');
        startEl.classList.remove('js-to-bold');
      }

      if (startEl.classList.contains('js-to-black')) {
        startEl.classList.add('m--black');
        startEl.classList.remove('js-to-black');
      }
    }
  }, 1200);

  // for scroll ani ------------------------------------------
  const itemHolderEls = document.querySelectorAll('.intro__holder');
  itemHolderEls.forEach(itemHolderEl => {
    itemHolderEl.dataset.random = Math.random();
  });

  // selector string as first argument
  const masonryEls = document.querySelectorAll('.masonry');
  masonryEls.forEach(masonryEl => {
    let colc = new Colcade( masonryEl, {
      columns: '.masonry__column',
      items: '.newsletter, .card',
    });
  });

  if ('splitter' in Once) Once.splitter.setSplitters(); 
  
  // browser color
  const background = getComputedStyle(document.body).getPropertyValue('background-color');
  document.querySelector('meta[name="theme-color"]').setAttribute('content', background);
  
  // switch ($pageType) {
  // }

  if ('fader' in Once && typeof Once.fader.init === 'function') Once.fader.init(); // has a safeguard against multiple inits

  // has vt and new page
  if (window.blPageTransition && 'fader' in Once) Once.fader.doSkipOnLoadInView(false); // false to not call setFaders, done below

  if ('observerUnblocker' in Once) Once.observerUnblocker(); // calls setResize()
};

const setSliderColors = (el) => {
  const activeSlide = el.swiper.slides[el.swiper.activeIndex];
  if (!activeSlide) return; // no active slide
  
  const slideEl = activeSlide.querySelector('.slide');
  // console.log({slideEl});
  if (slideEl) {
    const bgColor = slideEl.style.getPropertyValue('--bg-color');
    const color = slideEl.style.getPropertyValue('--color');

    // console.log({bgColor, color});
    const sectionEl = el.closest('.section');
    if (sectionEl) {
      sectionEl.dataset.bg = bgColor;
      sectionEl.dataset.color = color;
      Scroll.setPrevSection(-1); // reset previous section to force color update
      Scroll.setScroll();
    }
  }
};